import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";

export default function Uploader({ file, preview, onPick, onClear }) {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);

  return (
    <div
      data-testid="studio-uploader"
      onDragOver={(e) => {
        e.preventDefault();
        setDrag(true);
      }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        onPick(e.dataTransfer.files?.[0]);
      }}
      onClick={() => !preview && inputRef.current?.click()}
      className={`border border-dashed p-8 text-center cursor-pointer transition-colors duration-300 ${
        drag ? "border-gold bg-gold/5" : "border-white/20 hover:border-gold/60"
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        data-testid="studio-file-input"
        onChange={(e) => onPick(e.target.files?.[0])}
      />
      {preview ? (
        <div className="relative inline-block">
          <img
            src={preview}
            alt="Upload preview"
            className="mx-auto max-h-56 w-auto border border-line"
            data-testid="studio-upload-preview"
          />
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
            data-testid="studio-upload-clear"
            className="absolute -top-2 -right-2 bg-ink border border-line p-1.5 text-mute hover:text-bone"
            aria-label="Remove photo"
          >
            <X size={12} />
          </button>
        </div>
      ) : (
        <div className="py-4">
          <ImagePlus size={22} className="mx-auto text-mute" />
          <p className="font-display italic text-lg mt-3">Drag a photo here, or click to browse</p>
          <p className="font-meta text-[9px] uppercase tracking-[0.3em] text-mute mt-2">
            JPG · PNG · WEBP — up to 25 MB
          </p>
        </div>
      )}
    </div>
  );
}
